export const sdgGoals = [
  { number: 1, label: 'No Poverty', color: '#E5243B', delay: 'd1' },
  { number: 2, label: 'Zero Hunger', color: '#DDA63A', delay: 'd1' },
  { number: 5, label: 'Gender Equality', color: '#FF3A21', delay: 'd2' },
  { number: 10, label: 'Reduced Inequalities', color: '#DD1367', delay: 'd2' },
  { number: 11, label: 'Sustainable Cities', color: '#FD9D24', delay: 'd3' },
  { number: 13, label: 'Climate Action', color: '#3F7E44', delay: 'd3' },
  { number: 15, label: 'Life on Land', color: '#56C02B', delay: 'd4' },
  { number: 17, label: 'Partnerships', color: '#19486A', delay: 'd4' },
];
